import type { TFunction } from 'i18next'

const EMC_PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS = {
  validate_requirements:
    'v2.pages.products.detail.emcFiles.declarationOfConformity.progress.validateRequirements',
  render_pdf:
    'v2.pages.products.detail.emcFiles.declarationOfConformity.progress.renderPdf',
  persist_output_document:
    'v2.pages.products.detail.emcFiles.declarationOfConformity.progress.persistOutputDocument',
} as const

type EmcProductComplianceFileDeclarationOfConformityProgressStep =
  keyof typeof EMC_PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS

export function emcProductComplianceFileDeclarationOfConformityProgressMessage(
  step: string,
  translate: TFunction<'common'>
): string | null {
  const key =
    EMC_PRODUCT_COMPLIANCE_FILE_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS[
      step as EmcProductComplianceFileDeclarationOfConformityProgressStep
    ]
  if (key == null) {
    return null
  }
  return translate(key)
}
